import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconChevron } from 'assets/icons/svgs/icon-right-chevron.svg';
import { scrollSection } from './date-picker-utils';

export const MonthRange = (props) => {
  const { years, selectedMonth, setMonthHandler, monthSwiperWrapRef, monthSwiperRef, calendarRef } =
    props;
  const [monthNavVisible, setMonthNavVisible] = useState(false);
  const [monthPrevDisabled, setMonthPrevDisabled] = useState(true);
  const [monthNextDisabled, setMonthNextDisabled] = useState(false);
  const [scrollAmount, setScrollAmount] = useState(0);

  const monthButtonsClickHandler = (event, monthIdentifier) => {
    setMonthHandler(monthIdentifier);

    event.preventDefault();
  };

  const navLeftBtnClickHandler = () => {
    const swiperRef = monthSwiperRef.current;
    scrollSection({
      swiperType: 'month',
      swiperRef,
      direction: 'left',
      scrollAmount,
    });

    setMonthPrevDisabled(swiperRef.scrollLeft - scrollAmount <= 0);
    setMonthNextDisabled(false);
  };

  const navRightBtnClickHandler = () => {
    const swiperRef = monthSwiperRef.current;
    scrollSection({
      swiperType: 'month',
      swiperRef,
      direction: 'right',
      scrollAmount,
    });

    setMonthPrevDisabled(false);
    setMonthNextDisabled(
      swiperRef.scrollLeft + scrollAmount >= swiperRef.scrollWidth - swiperRef.offsetWidth
    );
  };

  const handleNavButtonsDisplay = () => {
    const swiperWrap = monthSwiperWrapRef.current;
    const swiper = monthSwiperRef.current;

    setMonthNavVisible(swiper.scrollWidth > swiperWrap.scrollWidth);
  };

  useEffect(() => {
    setTimeout(() => {
      handleNavButtonsDisplay();
    }, 300);

    setScrollAmount(Math.floor((calendarRef.current.offsetWidth * 65) / 100));

    window.addEventListener('resize', handleNavButtonsDisplay);
    return () => window.removeEventListener('resize', handleNavButtonsDisplay);
  }, []);

  return (
    <div className="swiper-wrap month-range" data-selector="month" ref={monthSwiperWrapRef}>
      {monthNavVisible && (
        <button
          type="button"
          className={`btn calendar-nav-btn btn-prev ${monthPrevDisabled ? 'disabled' : ''}`}
          onClick={navLeftBtnClickHandler}
          disabled={monthPrevDisabled}
        >
          <IconChevron className="icon left-chevron" />
          <span className="sr-only">Previous month</span>
        </button>
      )}
      <div
        className={`swiper month-swiper ${monthNavVisible ? 'nav-visible' : ''}`}
        ref={monthSwiperRef}
      >
        {years?.map((year, key) => (
          <ul className="range month-selector" key={key}>
            <li className="year">{year.Description}</li>

            {year.Months?.map((month, index) => (
              <li key={index}>
                {month.Active ? (
                  <a
                    href="#"
                    className={`month-element ${
                      month.Identifier === selectedMonth ? 'selected' : ''
                    }`}
                    onClick={(event) => monthButtonsClickHandler(event, month.Identifier)}
                  >
                    {month.Description}
                  </a>
                ) : (
                  <span
                    className={`month-element unavailable ${
                      month.Identifier === selectedMonth ? 'selected' : ''
                    }`}
                    onClick={(event) => event.preventDefault()}
                  >
                    {month.Description}
                  </span>
                )}
              </li>
            ))}
          </ul>
        ))}
      </div>
      {monthNavVisible && (
        <button
          type="button"
          className={`btn calendar-nav-btn btn-next ${monthNextDisabled ? 'disabled' : ''}`}
          onClick={navRightBtnClickHandler}
          disabled={monthNextDisabled}
        >
          <IconChevron className="icon" />
          <span className="sr-only">Next month</span>
        </button>
      )}
    </div>
  );
};

MonthRange.propTypes = {
  years: PropTypes.array,
  selectedMonth: PropTypes.string,
  setMonthHandler: PropTypes.func,
  monthSwiperWrapRef: PropTypes.object,
  monthSwiperRef: PropTypes.object,
  calendarRef: PropTypes.object,
};
